import { render, staticRenderFns } from "./SaleCOGS.vue?vue&type=template&id=7e7ea9bb&"
import script from "./SaleCOGS.vue?vue&type=script&lang=js&"
export * from "./SaleCOGS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports